module.exports = __webpack_public_path__ + "static/media/st-joseph.01447921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/st-joseph.png
// module id = 634
// module chunks = 0